import { message } from "antd";
import endpoints from "../utils/endpoints";
import { removeEmpty } from "../utils/objectUtils";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";

export async function getDeviceVersionsList(params?: any){
  let res = {
    count: 0,
    page: null,
    perpage: 0,
    list: [],
  };
  if(params) {
    params = removeEmpty(params)
  }
  await Api.get(endpoints.getDeviceVersionsList, {params}).then((response) => {
    res = response.data
  }).catch((err: string) => {
    notificationError(`Could not get device versions`)
  })
  
  return res
}

export async function exportCsvDevicesVersions(){
  let res = ''
  await Api.get(endpoints.exportCsvDeviceVersions).then((response) => {
    res = response.data
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })
  window.open("data:text/csv;charset=utf-8," + escape(res))
}

export async function deleteDevicesVersionById(params: any){
  await Api.get(endpoints.deleteDeviceVersionById, {params}).then((response) => {
    if(response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Version deleted successfully')
      }
    }
  }).catch((err: string) => {
    notificationError('Could not get data from servers')
  })
}

export async function createOrUpdateDeviceVersions (payload: any) {

  await Api.post(endpoints.createOrUpdateDeviceVersions, payload).then((response) => {
    if(response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Request sent successfully')
      }
    } else {
      notificationError('Could not send request to the server')
    }
  }).catch((err: string) => {
    notificationError('Could not send request to the server')
  })

}

export async function getDeviceVersionById (params: any) {
  
  let res = {
    deviceActivationEnabled: true,
    deviceType: "POS",
    deviceVersion: "",
    updateTimestamp: "",
    validThrough: "",
    posBundleServerEnabled: false,
  };

  await Api.get(endpoints.getDeviceVersionById, {params}).then((response) => {
    res = response.data
    if(!res || res.deviceVersion === '') {
      notificationError('Unable to get device information')
    }
  }).catch((err: string) => {
    notificationError('Unable to get device information')
  })

  return res
}
